import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'support_pack';
export const route = 'support_pack/[bookingId]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/SupportPackPage')));